import { render, staticRenderFns } from "./MenuTreeItem.vue?vue&type=template&id=64f5d4a0&scoped=true&"
import script from "./MenuTreeItem.vue?vue&type=script&lang=js&"
export * from "./MenuTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5d4a0",
  null
  
)

export default component.exports